import { render, staticRenderFns } from "./CommunicationEntry.vue?vue&type=template&id=f0226f20&scoped=true&"
import script from "./CommunicationEntry.vue?vue&type=script&lang=js&"
export * from "./CommunicationEntry.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationEntry.vue?vue&type=style&index=0&id=f0226f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0226f20",
  null
  
)

export default component.exports